import { render, staticRenderFns } from "./Comissão.vue?vue&type=template&id=000a8a3c&scoped=true"
import script from "./Comissão.vue?vue&type=script&lang=js"
export * from "./Comissão.vue?vue&type=script&lang=js"
import style0 from "./Comissão.vue?vue&type=style&index=0&id=000a8a3c&prod&lang=css"
import style1 from "./Comissão.vue?vue&type=style&index=1&id=000a8a3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000a8a3c",
  null
  
)

export default component.exports